export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8858.d37c0e00.jpg";